import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {ReportProfileService} from "../../../../services/archive/report-profile.service";
import {ProfileAbsComponent} from "../profile-abs.component";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {ReportTask} from "../../../../model/archive/report-task";
import {NotificationService} from "../../../../services/security/notification.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {CCRolesType} from "../../../../model/security/cc-roles-type";
import {CcStorageService} from "../../../../services/common/cc-storage.service";
import {UserInfoStorageService} from "../../../../services/auth/user-info-storage.service";

@Component({
  selector: 'app-archive-report-profile',
  templateUrl: './report-profile.component.html',
  styleUrls: ['../profile-abs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ReportProfileComponent extends ProfileAbsComponent {

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              reportProfileService: ReportProfileService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              reportTaskService: ReportTaskService,
              notificationService: NotificationService,
              appConfigService: AppConfigService,
              storageService: CcStorageService,
              userInfoStorageService: UserInfoStorageService) {
    super(ReportTask.Origin.WEB_REPORT, cdref, componentFactoryResolver, messageService, confirmationService,
      translateService, reportProfileService, reportTaskService, notificationService, commonFieldService, appConfigService, storageService,
      userInfoStorageService);
    this.transPartKey = 'profile.report';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected isProfileGroupAdmin(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_GROUP_ADMIN]);
  }

  protected isProfileScheduleAdmin(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_SCHEDULE_ADMIN]);
  }

  protected isProfileGroupLimited(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_GROUP_LIMITED]);
  }
}

